/*
  Area Rug PDP — size-variant selection.

  Data comes from the #RugVariantData JSON block rendered by
  templates/product.area-rugs.liquid (ids, formatted prices, SKUs, availability
  and per-variant image). On selection this updates the price, the SKU in the
  spec table, the gallery, the hidden variant id posted by #AddToCartForm, and
  the ?variant= parameter in the address bar.

  The add-to-cart contract is deliberately unchanged from the flooring PDP —
  form #AddToCartForm with [name="id"] and [name="quantity"] — so the cart
  drawer interceptor in global.js keeps working untouched.
*/
(function () {
  var variants = [];
  var slideIndexByImage = {};

  function readVariants() {
    var node = document.getElementById('RugVariantData');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  /*
    Reduce a Shopify CDN image URL to a comparable key: filename only, no query
    string, with any _800x800 / _120x120 size suffix removed. Lets a variant's
    featured_image be matched to the gallery slide built with product_img_url.
  */
  function imageKey(url) {
    if (!url) return '';
    var file = String(url).split('?')[0].split('/').pop();
    return file.replace(/_(\d+)?x(\d+)?(?=\.[a-z0-9]+$)/i, '');
  }

  function indexSlides() {
    slideIndexByImage = {};
    var slides = document.querySelectorAll('.image-section .mySlides img');
    for (var i = 0; i < slides.length; i++) {
      var key = imageKey(slides[i].getAttribute('src'));
      // First slide wins when several variants share an image.
      if (key && !(key in slideIndexByImage)) slideIndexByImage[key] = i + 1;
    }
  }

  // Owned by assets/product-gallery.js, which every product template loads.
  function showSlide(index) {
    if (window.rrProductMedia) window.rrProductMedia.showSlide(index);
  }

  function setText(selector, value) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = value == null ? '' : value;
    }
  }

  function findVariant(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function variantFromQuery() {
    var match = /[?&]variant=(\d+)/.exec(window.location.search);
    return match ? findVariant(match[1]) : null;
  }

  function updateUrl(variant) {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    params.set('variant', variant.id);
    window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
  }

  function select(variant, fromUser) {
    if (!variant) return;

    var idInput = document.getElementById('productSelect');
    if (idInput) idInput.value = variant.id;

    setText('[data-rug-price]', variant.price);
    setText('[data-rug-size-selected]', variant.title);
    setText('[data-rug-sku]', variant.sku);

    var compare = document.querySelector('[data-rug-compare-wrap]');
    if (compare) {
      if (variant.compareAt) {
        setText('[data-rug-compare]', variant.compareAt);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    var button = document.getElementById('AddToCart');
    if (button) {
      button.disabled = !variant.available;
      var label = button.querySelector('[data-rug-atc-label]');
      if (label) label.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    /*
      Only follow the variant image on a real selection, never on load. These
      rugs photograph the styled hero once and reuse one silo shot across most
      sizes, so switching on load would drop the visitor onto the plain silo.
    */
    if (fromUser) {
      var slide = slideIndexByImage[imageKey(variant.image)];
      var current = document.querySelector('.image-section .mySlides.active');
      var currentIndex = current ? Number((/\bimg-(\d+)\b/.exec(current.className) || [])[1]) : 0;
      if (slide && slide !== currentIndex) showSlide(slide);
      updateUrl(variant);
    }
  }

  function bindQuantity() {
    var input = document.getElementById('input');
    var mirror = document.getElementById('Quantity');
    if (!input || !mirror) return;

    function sync(value) {
      var next = Number(value);
      if (!next || next < 1) next = 1;
      input.value = next;
      mirror.value = next;
    }

    var minus = document.getElementById('minus');
    var plus = document.getElementById('plus');
    if (minus) {
      minus.addEventListener('click', function (e) {
        e.preventDefault();
        sync(Number(input.value) > 1 ? Number(input.value) - 1 : 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function (e) {
        e.preventDefault();
        sync(Number(input.value) + 1);
      });
    }
    input.addEventListener('change', function () { sync(input.value); });
    sync(input.value);
  }

  /*
    The buy box is gated on the product.sell-on-web metafield, matching the
    flooring PDP. ?preview_buybox=1 forces it on so the design can be reviewed
    before that metafield is set on these products.
  */
  function applyBuyboxPreview() {
    if (!/[?&]preview_buybox=1/.test(window.location.search)) return;
    // Two .rug-buybox blocks now — price above the colour swatches, size and
    // add-to-cart below them — so both have to be revealed.
    var buyboxes = document.querySelectorAll('.rug-buybox');
    for (var i = 0; i < buyboxes.length; i++) buyboxes[i].hidden = false;
    var offline = document.querySelector('.rug-offline');
    var note = document.querySelector('.rug-preview-note');
    if (offline) offline.hidden = true;
    if (note) note.hidden = false;
  }

  function init() {
    variants = readVariants();
    if (!variants.length) return;

    indexSlides();
    applyBuyboxPreview();
    bindQuantity();

    var radios = document.querySelectorAll('.rug-size__input');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        select(findVariant(this.value), true);
      });
    }

    // Deep link wins, then whatever Liquid pre-checked, then first available.
    var initial = variantFromQuery();
    if (!initial) {
      var checked = document.querySelector('.rug-size__input:checked');
      initial = checked ? findVariant(checked.value) : null;
    }
    if (!initial) {
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available) { initial = variants[j]; break; }
      }
    }
    if (!initial) initial = variants[0];

    var radio = document.getElementById('rug-size-' + initial.id);
    if (radio && !radio.disabled) radio.checked = true;
    select(initial, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
